import { render, staticRenderFns } from "./ComplianceDetailsModal.vue?vue&type=template&id=a04fae88&"
import script from "./ComplianceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ComplianceDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports